import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "rgb(255, 192, 1)",
    },
    secondary: {
      main: "#f44336",
    },
    danger: {
      main: "#ff0800",
    },
    background: {
      default: "#111",
      paper: "#1a1a1a",
    },
    text: {
      primary: "#fff",
      secondary: "#ccc",
    },
    divider: "#333",
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a",
          color: "#fff",
          borderRadius: "10px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a",
          color: "#fff",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        contained: {
          backgroundColor: "rgb(255, 192, 1)",
          color: "#000",
          "&:hover": {
            backgroundColor: "rgb(230, 173, 1)",
          },
        },
        outlined: {
          borderColor: "#333",
          color: "#fff",
          "&:hover": {
            borderColor: "rgb(255, 192, 1)",
            backgroundColor: "rgba(255, 192, 1, 0.08)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            color: "#fff",
            "& fieldset": {
              borderColor: "#333",
            },
            "&:hover fieldset": {
              borderColor: "#555",
            },
            "&.Mui-focused fieldset": {
              borderColor: "rgb(255, 192, 1)",
            },
          },
          "& .MuiInputLabel-root": {
            color: "#ccc",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "rgb(255, 192, 1)",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: "#333",
          color: "#fff",
        },
        head: {
          backgroundColor: "#1a1a1a",
          color: "#ccc",
          fontWeight: 600,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#1a1a1a",
          color: "#fff",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
        icon: {
          color: "#ccc",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#333",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderColor: "#333",
        },
        outlined: {
          borderColor: "#333",
          color: "#ccc",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: "#1a1a1a",
          color: "#fff",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#2a2a2a",
          },
          "&.Mui-selected": {
            backgroundColor: "#333",
            "&:hover": {
              backgroundColor: "#2a2a2a",
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#333",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#ccc",
          "&.Mui-selected": {
            color: "rgb(255, 192, 1)",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "rgb(255, 192, 1)",
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          "& .MuiPaginationItem-root": {
            color: "#ccc",
            borderColor: "#333",
            "&.Mui-selected": {
              backgroundColor: "rgb(255, 192, 1)",
              color: "#000",
            },
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a",
          color: "#fff",
          "&:before": {
            backgroundColor: "#333",
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#1a1a1a",
          color: "#fff",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#2a2a2a",
          },
          "&.Mui-selected": {
            backgroundColor: "#333",
            "&:hover": {
              backgroundColor: "#2a2a2a",
            },
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: "#fff",
        },
        secondary: {
          color: "#ccc",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#333",
          color: "#fff",
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: "#555",
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: "rgb(255, 192, 1)",
        },
      },
    },
  },
});

export default theme;
